<!--
  -  Copyright (c) Qwoach LLC 2021. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 1/12/2021
  -->

<template>
    <div class="qw-row" :class="{'ignore-events': readonly}">



        <el-slider
			v-if="!showAsBuckets"
            class="col px-2"
            v-model="rangeItem.range"
            range
            :show-stops="max < 31"
            :marks="marks"
            :max="max"
            @change="notifyValueChanged">
        </el-slider>

        <qw-input-number
			v-if="!showAsBuckets"
            v-model="rangeItem.min"
            :input-debounce-delay="1000"
            :readonly="readonly"
            class="text-center-input mr-1 ml-4"
            @change="notifyValueChanged"/>

        <small class="text-muted" v-if="!showAsBuckets">to</small>

        <qw-input-number
			v-if="!showAsBuckets"
            v-model="rangeItem.max"
            :input-debounce-delay="1000"
            :readonly="readonly"
            class="text-center-input ml-1 mr-4"
            @change="notifyValueChanged"/>

		<div v-if="showAsBuckets"
			 class="bold mr-2"
			 style="padding-bottom: 6px;">
			Bucket {{index + 1}}:
		</div>

        <qw-input
            class="col"
            v-model="rangeItem.label"
            :readonly="readonly"
            :multiline="true"
            placeholder="Outcome description (visible to client)"
            @change="notifyValueChanged"
            ></qw-input>

        <qw-button-delete v-if="!readonly" @click="onDeleteClicked"/>

    </div>
</template>

<script>

import BaseVModelView from "@/core/components/BaseVModelView.vue";
import QwButtonDelete from "@/core/components/Controls/Buttons/QwButtonDelete.vue";
import {deleteConfirmDialog} from "@/core/components/Dialogs/dialog";

export default {
    name: "ScoreResultRangeView",
    components: {QwButtonDelete},
    extends: BaseVModelView,

    props: {
        max: {Number, required: true},
        readonly: Boolean,
		showAsBuckets: Boolean,
		index: Number,
    },

    methods: {

        async onDeleteClicked() {
            let res = await deleteConfirmDialog({itemName: "range"})
            if(res){
                this.$emit("delete")
            }
        }
    },

    computed: {

        rangeItem: {
            get: function () {
                return this.valueData
            },
            set: function (res) {
                this.valueData = res
            }
        },

        marks() {
            return {}
            // let res = {"0": "0"}
            // let step = 5
            // let i = step
            // while(i <= this.max - step){
            //     res[i] = "" + i
            //     i += step
            // }
            // res[this.max] = "" + this.max
            // return res

        }
    },
}
</script>

<style lang="scss">

</style>
